import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class PositioningType extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, PositioningType._types);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static PARENT_DIRECTED = new AString('Parent Directed');
    public static SELF_DIRECTED = new AString('Self Directed');

    private static _types:Array<AString> = [
        PositioningType.PARENT_DIRECTED,
        PositioningType.SELF_DIRECTED
    ];

    public static parentDirected():PositioningType
    {
        return new PositioningType(PositioningType.PARENT_DIRECTED);
    }

    public static selfDirected():PositioningType
    {
        return new PositioningType(PositioningType.SELF_DIRECTED);
    }

    public static isParentDirected(type:PositioningType):boolean
    {
        return PositioningType.parentDirected().isEqualTo(type);
    }

    public static isSelfDirected(type:PositioningType):boolean
    {
        return PositioningType.selfDirected().isEqualTo(type);
    }

    public static fromString(value:string):PositioningType
    {
        return new PositioningType(AString.fromString(value));
    }
}
